

export const buscarProducto = (carrito=[], productoId) => {
    const encontrado = carrito.find((item) => item.producto._id === productoId);
    return encontrado ? encontrado.id : null;
};



export const buscarProductoPrendas = (carrito=[], producto, color, talla, genero) => {
    const encontrado = carrito.find((item) => 
        item.producto._id === producto &&
        item.color === color &&
        item.talla === talla &&
        item.genero === genero
    );

    return encontrado ? encontrado.id : null;
};



export const buscarProductoColor = (carrito=[], producto, color) => {
    const encontrado = carrito.find((item) => 
        item.producto._id === producto &&
        item.color === color
    );

    return encontrado ? encontrado.id : null;
};




export const buscarProductoEstructuras = (carrito=[], producto, medida, alto, ancho) => {
    const encontrado = carrito.find((item) =>
        item.producto._id === producto &&
        item.unidadMedida === medida &&
        item.alto === alto &&
        item.ancho === ancho
    );

    return encontrado ? encontrado.id : null;
};




export const buscarProductoCorteVinilo = (carrito=[], producto, color, medida, alto, ancho) => {
    const encontrado = carrito.find((item) =>
        item.producto._id === producto &&
        item.color === color &&
        item.unidadMedida === medida &&
        item.alto === alto &&
        item.ancho === ancho
    );

    return encontrado ? encontrado.id : null;
};
















